import { blue } from '@mui/material/colors'
import { isProductTypeSpot, isSymbolLike } from './exchange-utils'

export function convertHSBToRGB (h: number, s: number, b: number): number[] {
  s /= 100
  b /= 100
  const k = (n: number): number => (n + h / 60) % 6
  const f = (n: number): number => b * (1 - s * Math.max(0, Math.min(k(n), 4 - k(n), 1)))
  return [255 * f(5), 255 * f(3), 255 * f(1)]
}

export function scaleBetween (unscaledNum: number, minAllowed: number, maxAllowed: number, min: number, max: number): number {
  return (maxAllowed - minAllowed) * (unscaledNum - min) / (max - min) + minAllowed
}

export function getProductTypeColour (value: string): string {
  if (!isSymbolLike(value)) {
    return ''
  } else {
    return isProductTypeSpot(value) ? blue[500] : '#ffffff'
  }
}
